<cue-declarative-map-marker pane="path" [zIndexOffset]="1600" [geoJson]="geoJson()">
  <div *cueDeclarativeMapMarkerTemplate class="map-route-note-marker-host">
    @if (isOpen()) {
      <div class="route-note-label">
        @if (marker().title | localizedString) {
          <h4>{{ marker().title | localizedString }}</h4>
        }
        @if (marker().description | localizedString) {
          <p>{{ marker().description | localizedString }}</p>
        }
      </div>
    }
    <button class="route-note-marker" type="button" (click)="toggleLabel($event)">{{ marker().number }}</button>
  </div>
</cue-declarative-map-marker>
